import { useContext } from 'react';
import {
  LoadingActionsContext,
  LoadingContext,
} from '../context/loadingContext';

export const useLoadingStatus = () => {
  const context = useContext(LoadingContext);

  if (!context)
    throw new Error('useAuth must be used within a AuthContextProvider');

  return context;
};

export const useLoadingStatusActions = () => {
  const context = useContext(LoadingActionsContext);

  if (!context)
    throw new Error(
      'useAuthActions must be used within a AuthActionsContextProvider',
    );

  return context;
};
